import React, { useState } from 'react';
import { StyleSheet, Text, View, ScrollView } from 'react-native';
import ForceUpdateModal from './ForceUpdateModal';
import { useAuth } from 'app/auth/hooks/useAuth';
import { Can } from '@shared/components/Can';
import { NavigationProp } from '@react-navigation/native';
import { AuthStackParamList } from '../types/Navigation';
import { useTranslation } from 'react-i18next';
import Button from '@md-design-system/Button/Button';
import { colorPalette } from '@shared/config/colorsConfig';
import { NotificationTester, AlertLogicTester } from '@shared/components/test';
import WsMessagesScreen from '@shared/components/test/WebSocketTest';
interface DummyScreenProps {
    navigation: NavigationProp<any>;
}

const DummyScreen = ({ navigation }: DummyScreenProps) => {
    const { logout, user, meData } = useAuth();
    const [forceUpdateVisible, setForceUpdateVisible] = useState(false);

    const changePage2 = () => {
        navigation.navigate('Page2');
        console.log('navigating to page 2')
    };



    return (
        <ScrollView style={[styles.container]}>
            <ForceUpdateModal visible={forceUpdateVisible} onDismiss={() => setForceUpdateVisible(false)} />

            <View style={{ height: 40 }} />

            <NotificationTester />
            <AlertLogicTester />

            <Text style={[styles.userInfo, { color: colorPalette.primary[700] }]}>
                User data: {JSON.stringify(user, null, 2)}

                Me data: {JSON.stringify(meData, null, 2)}
                {user?.email && ` Logged in as: ${user.email}`}
            </Text>
            <WsMessagesScreen />

            {/* Sezione bottoni esistenti */}
            <View style={styles.section}>

                <Can req={{ all: ['exam::create'] }}>
                    <Button variant="primary" size='large' onPress={() => { }}>
                        Primary
                    </Button>
                    <Button variant='outline' size='large' onPress={() => { }}>
                        Permission Button
                    </Button>
                    <Button variant='secondary' size='large' onPress={() => { }}>
                        Permission Button
                    </Button>
                    <Button variant='secondary-outline' size='large' onPress={() => { }}>
                        Permission Button
                    </Button>
                    <Button variant='danger' size='large' onPress={() => { }}>
                        Permission Button
                    </Button>
                    <Button variant='danger-outline' size='large' onPress={() => { }}>
                        Permission Button
                    </Button>
                    <Text style={{ color: colorPalette.success[500] }}>Permission - exam::create</Text>
                </Can>

                <Button
                    variant='primary'
                    size='large'
                    onPress={changePage2}
                >
                    Vai a Pagina 2
                </Button>
                <View className='h-100 bg-primary-100'>

                </View>
                <Button
                    variant='outline'
                    size='large'
                    onPress={() => setForceUpdateVisible(true)}
                >
                    [DEV] Force Update Modal
                </Button>
                <Button
                    variant="danger"
                    size='large'
                    onPress={logout}
                >
                    Logout
                </Button>
            </View>

        </ScrollView>
    );
};
const styles = StyleSheet.create({
    container: {
        paddingTop: 20,
        paddingHorizontal: 16
    },
    userInfo: {
        padding: 20,
        fontSize: 12,
        lineHeight: 18,
    },
    section: {
        marginVertical: 20,
        paddingHorizontal: 10,
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: '600',
        marginBottom: 15,
    },
    button: {
        marginVertical: 5,
    },
    buttonRow: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginVertical: 10,
        flexWrap: 'wrap',
        gap: 10,
    },
});

export default DummyScreen;
